
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Gutter from '@/ui-kit/components/gutter';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
} from '@/ui-kit/styles/enums';
import ListWithImage from './list-image';

export default {
  name: 'MyAbodeOverviewMainSectionContent',
  components: {
    Typography,
    Gutter,
    ListWithImage,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => ([]),
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    buttonText: {
      type: String,
      default: '',
    },
    redirectTo: {
      type: String,
      default: '',
    },
    trackEvent: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TypographyType,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
    };
  },
};
